import { render, staticRenderFns } from "./EditarPerfil.vue?vue&type=template&id=2b93ae8a&scoped=true"
import script from "./EditarPerfil.vue?vue&type=script&lang=js"
export * from "./EditarPerfil.vue?vue&type=script&lang=js"
import style0 from "./EditarPerfil.vue?vue&type=style&index=0&id=2b93ae8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b93ae8a",
  null
  
)

export default component.exports